import React, { useState } from "react";
import MonoButton from "./MonoButton";
import { useAuth } from "../auth/AuthContext";

const PasswordChangeModal = ({ onClose }) => {
  const { userId, setMustChangePassword } = useAuth();

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await fetch("https://www.denisbitter.de/stage01/api/change_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword,
        }),
      });

      const data = await res.json();
      if (data.success) {
        setMustChangePassword(false);
        onClose();
      } else {
        setMessage(data.message || "Fehler beim Speichern.");
      }
    } catch (err) {
      setMessage("Serverfehler. Bitte später versuchen.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl font-mono">
        <h2 className="text-lg font-semibold mb-4">Bitte neues Passwort setzen</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            name="currentPassword"
            placeholder="Aktuelles Passwort"
            value={formData.currentPassword}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />

          <input
            type="password"
            name="newPassword"
            placeholder="Neues Passwort"
            value={formData.newPassword}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />

          {message && <p className="text-red-500 text-sm">{message}</p>}

          <MonoButton type="submit" className="w-full">
            Passwort speichern
          </MonoButton>
        </form>
      </div>
    </div>
  );
};

export default PasswordChangeModal;
